/*
 * @Author: Cphayim
 * @Date: 2019-06-28 15:55:34
 * @LastEditTime: 2022-03-04 16:27:07
 * @Description: 导入所有全局样式文件
 */

import './all.scss'
import './reset.scss'
import './theme.scss'
import './transtion.scss'
import './tailwind.scss'
